import {
    type MakeRouteMatch,
    type RegisteredRouter,
    useMatch,
} from "@tanstack/react-router";
import { useState } from "react";

type RouteTree = RegisteredRouter["routeTree"];

export const homeRouteId = "/_find/" as const;
const findRouteId = "/_find/find" as const;

export type FindRouteMatch =
    | MakeRouteMatch<RouteTree, typeof homeRouteId>
    | MakeRouteMatch<RouteTree, typeof findRouteId>;

export function useRetainedFindMatch() {
    const home = useMatch({ from: homeRouteId, shouldThrow: false });
    const find = useMatch({ from: findRouteId, shouldThrow: false });
    const activeMatch: FindRouteMatch | null = home ?? find ?? null;
    const [retainedMatch, setRetainedMatch] = useState(activeMatch);
    if (activeMatch !== null && activeMatch !== retainedMatch) {
        setRetainedMatch(activeMatch);
    }
    return { match: retainedMatch, active: activeMatch !== null };
}
